import { useState } from 'react';
import { calmTokens as t } from '../../shared/tokens';
import { fmtEUR } from '../../shared/format';
import CalmStatCard from './CalmStatCard';

export default function InitialBalanceCard({ value, onSave, loading }) {
  const [locked, setLocked] = useState(true);
  const [draft, setDraft] = useState('');

  const startEdit = () => {
    setDraft(String(value ?? 0));
    setLocked(false);
  };

  const commit = async () => {
    const parsed = parseFloat(draft);
    await onSave(Number.isFinite(parsed) ? parsed : 0);
    setLocked(true);
  };

  const handleEdit = () => {
    if (locked) startEdit();
    else commit();
  };

  return (
    <CalmStatCard
      label="Solde initial"
      value={fmtEUR(value, { sign: value < 0 })}
      editable
      onEdit={handleEdit}
      hint="Cliquez pour ajuster en début de mois"
    >
      {locked ? (
        <div
          style={{
            fontFamily: t.fontMono,
            fontSize: 'var(--stat-value)',
            fontWeight: 500,
            color: t.text,
            letterSpacing: -0.8,
            lineHeight: 'var(--stat-value-lh)',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {fmtEUR(value, { sign: value < 0 })}
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!loading) commit();
          }}
          style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}
        >
          <input
            type="number"
            step="0.01"
            autoFocus
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={() => {
              if (!loading) commit();
            }}
            className="calm-stat-input"
            style={{
              fontFamily: t.fontMono,
              fontSize: 'var(--stat-value)',
              fontWeight: 500,
              color: t.text,
              letterSpacing: -0.8,
              fontVariantNumeric: 'tabular-nums',
              background: 'transparent',
              border: 'none',
              borderBottom: `2px solid ${t.accent}`,
              outline: 'none',
              padding: '2px 4px',
              width: '100%',
              boxSizing: 'border-box',
            }}
          />
        </form>
      )}
    </CalmStatCard>
  );
}
